import { ChangeDetectionStrategy, Component, ViewEncapsulation, booleanAttribute, input } from '@angular/core';

/**
 * A card for grids of items. Slots: `[cardMedia]`, `[cardTitle]`,
 * `[cardMeta]`, `[cardBadges]`, `[cardActions]` (footer buttons) and
 * `[cardMenu]` (top-right). Mark the title's link or button `card-primary`
 * to make the whole card one click target; actions and the menu stay
 * separately clickable above it, and keyboard focus rings the whole card.
 */
@Component({
  selector: 'app-card-cabinet',
  templateUrl: './card.component.html',
  styleUrl: './card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom,
  host: {
    '[class.card--horizontal]': "layout() === 'horizontal'",
    '[class.card--selected]': 'selected()',
    '[class.card--disabled]': 'disabled()',
  },
})
export class CardCabinetComponent {
  /** `horizontal` puts a small thumbnail on the left. */
  readonly layout = input<'vertical' | 'horizontal'>('vertical');
  /** The chosen card in a pick-one set. */
  readonly selected = input(false, { transform: booleanAttribute });
  readonly disabled = input(false, { transform: booleanAttribute });
}
